"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sentry = require("./sentry");
Object.keys(_sentry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sentry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sentry[key];
    }
  });
});